(function() {
  const TGLProduct = window.TGLProduct = window.TGLProduct || {};

  function updatePrice(ctx, variant) {
    if (!ctx.priceEl || !variant) return;

    const price = Number(variant.price);
    const compareAt = Number(variant.compare_at_price);
    const isOnSale = Number.isFinite(compareAt) && compareAt > price && compareAt > 0;
    const format = (amount) => TGLProduct.formatMoney(amount, ctx.data.moneyFormat, ctx.data.currency);

    if (isOnSale) {
      const savingsPercent = Math.round(((compareAt - price) / compareAt) * 100);
      ctx.priceEl.innerHTML = `
        <span class="price-current">${format(price)}</span>
        <span class="price-compare">${format(compareAt)}</span>
        ${savingsPercent > 0 ? `<span class="price-badge">-${savingsPercent}%</span>` : ''}
      `;
      return;
    }

    ctx.priceEl.innerHTML = `<span class="price-current">${format(price)}</span>`;
  }

  TGLProduct.updatePrice = updatePrice;
})();
